import * as React from 'react';
import JuridicalPerson from 'src/entities/JuridicalPerson';
import Person from 'src/entities/Person';
import PhysicalPerson from 'src/entities/PhysicalPerson';
import ResultPageCardComponent from 'src/modules/commons/result-page/ResultPageCard.Component';
import MyAccountHeaderComponent from 'src/modules/my-account/partials/MyAccountHeader.component';
import JuridicalPersonData from 'src/value-objects/JuridicalPersonData';
import JuridicalPersonEditFormComponent from './forms/JuridicalPersonEditForm.component';

interface Props {
  juridicalPerson?: JuridicalPerson;
  formData: JuridicalPersonData;
  error: boolean;
  errorMessage: {};
  success: boolean;
  physicalPerson: PhysicalPerson;
  profilePicture?: File;
  cifDocument?: File;
  cifDocumentName?: string;
  deedCompany?: File;
  deedCompanyName?: string;
  companyStatutes?: File;
  companyStatutesName?: string;
  realOwnership?: File;
  realOwnershipName?: string;
  idRepresentatives?: File;
  idRepresentativesName?: string;
  notarialDeed?: File;
  notarialDeedName?: string;
  idFront?: File;
  idFrontName?: string;
  idBack?: File;
  idBackName?: string;
  defaultProfile: Person;
  checkboxState: boolean;
  canChangeCheckbox: boolean;
  lockCreateJuridicalPerson: boolean;
  handleSubmit(edit: boolean): void;
  handleChange(key: string): (value: string | File | boolean) => void;
  handleChangeSpouse(key: string): (value: string | File | boolean) => void;
  handleChangeDefaultProfile(): void;
  handleChangeCheckbox(): void;
  handlePublicProfileCheckbox(): void;
}

class JuridicalPersonUpdateComponent extends React.PureComponent<Props> {
  public render(): React.ReactNode {
    return (
      <section>
        <div className="container">
          <MyAccountHeaderComponent pageTitle="Mi cuenta"/>
          <div className="gap-20"/>
          <div className="row">
            <div className="col-sm-12">
              <div className="">
                {!this.props.success ?
                  <JuridicalPersonEditFormComponent
                    juridicalPerson={this.props.juridicalPerson}
                    formData={this.props.formData}
                    handleSubmit={this.props.handleSubmit}
                    error={this.props.error}
                    errorMessage={this.props.errorMessage}
                    physicalPerson={this.props.physicalPerson}
                    handleChange={this.props.handleChange}
                    handleChangeSpouse={this.props.handleChangeSpouse}
                    profilePicture={this.props.profilePicture}
                    cifDocument={this.props.cifDocument}
                    cifDocumentName={this.props.cifDocumentName}
                    deedCompany={this.props.deedCompany}
                    deedCompanyName={this.props.deedCompanyName}
                    companyStatutes={this.props.companyStatutes}
                    companyStatutesName={this.props.companyStatutesName}
                    realOwnership={this.props.realOwnership}
                    realOwnershipName={this.props.realOwnershipName}
                    idRepresentatives={this.props.idRepresentatives}
                    idRepresentativesName={this.props.idRepresentativesName}
                    notarialDeed={this.props.notarialDeed}
                    notarialDeedName={this.props.notarialDeedName}
                    idFront={this.props.idFront}
                    idFrontName={this.props.idFrontName}
                    idBack={this.props.idBack}
                    idBackName={this.props.idBackName}
                    defaultProfile={this.props.defaultProfile}
                    handleChangeDefaultProfile={this.props.handleChangeDefaultProfile}
                    checkboxState={this.props.checkboxState}
                    canChangeCheckbox={this.props.canChangeCheckbox}
                    handleChangeCheckbox={this.props.handleChangeCheckbox}
                    handlePublicProfileCheckbox={this.props.handlePublicProfileCheckbox}
                    lockCreateJuridicalPerson={this.props.lockCreateJuridicalPerson}
                  /> :
                  <ResultPageCardComponent
                    title="Tu perfil de inversor se ha actualizado correctamente"
                    message="Ahora te resultará más cómodo invertir en las mejores oportunidades de inversión"
                    success={true}
                  />
                }
              </div>
            </div>
          </div>
          <div className="gap-20"/>
        </div>
      </section>
    );
  }
}

export default JuridicalPersonUpdateComponent;


// WEBPACK FOOTER //
// ./src/modules/my-account/juridical-profile-update/JuridicalPersonUpdate.component.tsx